import React from "react";
import { motion } from "framer-motion";
import portfolioData from "../../data/mock";
import { Badge } from "../ui/badge";

const SkillsGrid = () => {
  const { skills } = portfolioData;

  const skillIcons = {
    Azure: "AZ",
    AWS: "AWS",
    Kubernetes: "K8S",
    Terraform: "TF",
    Docker: "DKR",
    "ARM Templates": "ARM",
    "Azure DevOps": "ADO",
    "GitHub Actions": "GHA",
    "GitLab CI": "GLC",
    "CI/CD": "CI",
    Python: "PY",
    "Infrastructure as Code": "IaC"
  };

  return (
    <section id="skills" className="relative py-28 bg-ink-950">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-ink-800 to-transparent" />

      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-px bg-brand-400" />
            <span className="text-brand-400 text-sm font-medium tracking-wider uppercase">
              Skills
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-2">
            Technical Toolkit
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {skills.map((skill, index) => (
            <motion.div
              key={skill}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.06 }}
              className="group relative p-5 rounded-xl border border-ink-800/60 bg-ink-900/20 hover:border-brand-500/30 hover:bg-ink-900/50 transition-all duration-300 cursor-default"
            >
              <div className="text-xs font-mono text-brand-400/70 mb-3 tracking-wider">
                {skillIcons[skill] || skill.substring(0, 3).toUpperCase()}
              </div>
              <h3 className="text-white text-sm font-medium">{skill}</h3>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="mt-10 flex flex-wrap gap-2"
        >
          {[
            "Key Vault",
            "Azure AD",
            "Cosmos DB",
            "SQL Server",
            "Redis",
            "Linux",
            "Bash",
            "Grafana",
            "Prometheus",
            "Secrets Management",
            "Agile / SDLC"
          ].map(
            (tool) => (
              <Badge
                key={tool}
                variant="outline"
                className="text-slate-400 border-ink-800 hover:text-slate-200 hover:border-slate-600 text-xs font-normal transition-colors duration-200"
              >
                {tool}
              </Badge>
            )
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default SkillsGrid;
